import { Directive, ElementRef, Input, HostListener, Renderer2, OnDestroy, ViewContainerRef, ComponentRef } from '@angular/core';
import { OwcTooltip } from '@one/angular';

let anchorIdSequence = 0;

@Directive({
    selector: '[appTooltip]', standalone: false
})
export class TooltipDirective implements OnDestroy {
    @Input('appTooltip') text: string | undefined;

    tooltipElement!: HTMLElement | null;
    compRef!: ComponentRef<OwcTooltip> | null;

    constructor(protected readonly el: ElementRef,
        protected readonly renderer: Renderer2,
        public readonly vcRef: ViewContainerRef,
    ) { }

    ngOnDestroy(): void {
        this.hideTooltip();
    }

    @HostListener('mouseenter') onMouseEnter() {
        this.showTooltip();
    }

    @HostListener('mouseleave')
    @HostListener('click')
    onMouseLeave() {
        this.hideTooltip();
    }


    protected showTooltip() {
        if (this.compRef == null) {
            const tooltipElement = this.renderer.createElement('span');
            tooltipElement.textContent = this.text;
            this.tooltipElement = tooltipElement
            // owc-popover can only compute a Popper position (and therefore honor
            // strategy="fixed") when the anchor is resolvable via getElementById;
            // without an id, Popper never activates and the tooltip renders as a
            // plain static DOM node, still clipped by any ancestor's overflow.
            if (!this.el.nativeElement.id) {
                this.renderer.setAttribute(this.el.nativeElement, 'id', `app-tooltip-anchor-${++anchorIdSequence}`);
            }
            const componentRef = this.vcRef.createComponent(OwcTooltip, {
                projectableNodes: [[tooltipElement]]
            })
            componentRef.setInput('anchor', this.el.nativeElement.id)
            // owc-tooltip defaults to strategy="absolute", which gets clipped by any
            // ancestor's overflow (e.g. a scrollable table body) until scrolled into view.
            // "fixed" positions it relative to the viewport instead, same fix as owc-menu.
            componentRef.setInput('strategy', 'fixed')
            componentRef.setInput('visible', true)
            this.compRef = componentRef
            this.renderer.appendChild(this.el.nativeElement,
                componentRef.location.nativeElement
            );
            this.compRef.changeDetectorRef.detectChanges()
        }
    }


    protected hideTooltip() {
        if (this.tooltipElement && this.compRef) {
            this.renderer.removeChild(this.el.nativeElement, this.compRef.location.nativeElement);
            this.tooltipElement = null;
            this.compRef = null
        }
    }


}


@Directive({
    selector: '[appTooltipOnEllipsis]', standalone: false
})
export class TooltipOnEllipsisDirective extends TooltipDirective implements OnDestroy {
    @Input('appTooltipOnEllipsis') override text: string | undefined;

    @HostListener('mouseenter') override onMouseEnter() {
        if (this.shouldDisplayTooltip()) {
            this.showTooltip();
        }
    }

    private shouldDisplayTooltip(): boolean {
        return (this.el.nativeElement.clientWidth < this.el.nativeElement.scrollWidth);
    }

}
